import gql from 'graphql-tag';

export const PurchasedCustomPrintOrderSummaryFields = gql`
  fragment PurchasedCustomPrintOrderSummaryFields on PurchasedCustomPrint {
    id
    name
    quantity
    order_status
    album_folder_bulk_shipping {
      id
    }
    custom_print {
      id
      name
      description
    }
    transaction_item {
      __typename
      ... on ITransactionItem {
        id
        print_product_configurations {
          records {
            id
            quantity
            front_print_file_url
            print_product_configuration {
              id
              name
            }
            account_card {
              id
              front_preview_file_url
            }
          }
        }
      }
      ... on ITransactionCustomPrintItem {
        custom_print_name
      }
      ... on TransactionPhotoPrintPackageItem {
        print_package_name
        print_items {
          records {
            id
            quantity
            print_package_item_type_name
          }
        }
      }
      ... on TransactionPhotoPrintItem {
        photo_print_size_name
      }
      ... on TransactionPhotoPhotoPricingItem {
        photo_pricing_name
        print_items {
          records {
            id
            quantity
            print_package_item_type_name
          }
        }
      }
    }
    album {
      id
      name
    }
  }
`;

export const TransactionOrderSummaryFields = gql`
  fragment TransactionOrderSummaryFields on Transaction {
    id
    created_at
    email_address
    account {
      id
      name
      email_address
      phone_number
    }
    transaction_items(slice: { limit: 9999 }) {
      records {
        __typename
        ... on ITransactionItem {
          id
        }
        ... on TransactionPhotoPrintPackageItem {
          identity {
            id
            name
            last_name
          }
        }
        ... on ITransactionCustomPrintItem {
          identity {
            id
            name
            last_name
          }
        }
        ... on TransactionPhotoPhotoPricingItem {
          purchased_photo_pricing {
            id
            identity {
              id
              name
              last_name
            }
          }
        }
      }
    }
    purchased_custom_prints(slice: { limit: 9999 }) {
      records {
        ...PurchasedCustomPrintOrderSummaryFields
      }
    }
  }
  ${PurchasedCustomPrintOrderSummaryFields}
`;
